import {gql} from 'graphql-tag'
import {fragmentModuleNavigationLink, fragmentModuleMedia} from '../../../../core/data-layer/modules/fragments'

export default gql`
    ${fragmentModuleMedia}
    ${fragmentModuleNavigationLink}
    fragment ModuleReportsListItemFragment on ModuleReportsListItem {
        contentType: __typename
        sys {
            id
        }
        title
        text
        estimatedRelease
        tags
        isLocked
        image {
            ...ModuleMediaFragment
        }
        link {
            ...ModuleNavigationLinkFragment
        }
    }
`
